module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_kv-312e9030748f7e2372b26ec638637b1b.svg";